<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">

    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>{{ isRechazo ? 'Buscador de Rechazos de TRACES' : 'Buscador de Traslados de TRACES' }}</h4>

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">
                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPaisOrigen">País de origen</label>
                                    <ng-select [items]="listPaises"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="PaisOrigen"
                                               loadingText="Cargando..."
                                               [loading]="!(listPaises)"
                                               notFoundText="País de origen no encontrado"
                                               placeholder="-- Seleccione un país de origen --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('PaisOrigen')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPaisDestino">País de destino</label>
                                    <ng-select [items]="listPaises"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="PaisDestino"
                                               loadingText="Cargando..."
                                               [loading]="!(listPaises)"
                                               notFoundText="País de destino no encontrado"
                                               placeholder="-- Seleccione un país de destino --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('PaisDestino')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPaisEmision">País de emisión</label>
                                    <ng-select [items]="listPaises"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="PaisEmision"
                                               loadingText="Cargando..."
                                               [loading]="!(listPaises)"
                                               notFoundText="País de emisión no encontrado"
                                               placeholder="-- Seleccione un país de emisión --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('PaisEmision')"
                                               appendTo="body">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="time" class="col-form-label" for="inpFechaDecisionDesde">Fecha de decisión desde</label>
                                    <p-calendar formControlName="FechaDecisionDesde" inputStyleClass="form-control" [showIcon]="true"
                                                [ngClass]="displayFieldCss('FechaDecisionDesde')" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" appendTo="body" [maxDate]="form.value.FechaDecisionHasta"></p-calendar>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaDecisionDesde','required')">
                                        La Fecha Decisión Desde es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="time" class="col-form-label" for="inpFechaDecisionHasta">Fecha de decisión hasta</label>
                                    <p-calendar formControlName="FechaDecisionHasta" inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaDecisionHasta')"
                                                [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" appendTo="body" [minDate]="form.value.FechaDecisionDesde"></p-calendar>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaDecisionHasta','required')">
                                        La Fecha Decisión Hasta es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intCodigoTaric">Código TARIC del Producto/Embalaje</label>
                                    <input formControlName="CodigoTaric" name="CodigoTaric" class="form-control" inputStyleClass="form-control"
                                           [ngClass]="displayFieldCss('CodigoTaric')" type="text" value="" maxlength="10">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','CodigoTaric')">
                                        La cadena debe estar compuesta por una secuencia de entre 2 y 10 dígitos y que el total de dígitos sea par
                                    </div>
                                </div>
                               

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intBusquedaExacta">Búsqueda exacta (del Código TARIC)</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNo"
                                                    formControlName="BusquedaExacta"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button [disabled]="disableSearchBtn" name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
